export function smoked_at_least_one_year(years: string) {
  return parseInt(years) >= 1;
}

export function at_least_5_per_day(cigarettes_per_day: string) {
  return parseInt(cigarettes_per_day) >= 5;
}
